module.exports = __webpack_public_path__ + "static/img/celoscope-detail-27.651ddb6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-detail-27.jpg
// module id = QrmR
// module chunks = 52